<div class="mainContainer managerMain fieldMain">
    <div class="overlay"></div>
    <div class="sidePanel">
        <div class="logoSec">
            <a href="#" class="logo"><span class="logoImg"><img src="assets/img/logo.png" alt=""></span><span
                    class="logoText"><img src="assets/img/logoText.png" alt=""></span></a>
        </div>

        <ul class="helpSec">

            <li class="profile">
                <a href="#">
                    <span class="icon">
                        <img *ngIf="!profilePic" src="assets/img/default.jpg" alt="">
                        <img *ngIf="profilePic" src="{{imageViewUrl}}{{profilePic}}" alt="">
                
                    </span>
                    <span class="text">{{userName | slice:0:11}}
                        <span *ngIf="userName && userName.length >11">...</span>
                    </span>
                
                    <span class="helpArrow">
                        <i class="material-icons">keyboard_arrow_right</i>
                    </span>
                </a>
                <div class="subNav singleSubNav">
                    <ul class="subNavList">
                        <!-- <li><a href="#" id="fiterSecTrigger"><i class="material-icons-outlined">feedback</i>Feedback</a>
                        </li> -->
                        <li (click)="navigateToPage();"><a href="#"><i class="material-icons-outlined">power_settings_new</i>Logout</a></li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
    <div class="mainPanel reportMainPanel clientMainPanel">
        <div class="midPanel">
            <div class="fullPanel">
                <div class="breadcrumbSec">
                    <a id="naviconLeft" href="#" class="navicon"><img src="assets/img/hamburgerIcon.png" alt=""></a>
                    <div class="breadcrumbText">
                        <p><a href="#">Home</a> </p>
                    </div>
                    <div class="topTabs">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown">{{selectedSectionHeader}} <span class="arrowRight"><i
                                    class="material-icons">keyboard_arrow_down</i></span></a>
                        <div class="dropdown-menu">
                            <a  (click)="moveTo(1);" class="dropdown-item" data-menuanchor="/get-started#firstPage1" href="#">Get Started</a>
                            <a  (click)="moveTo(2);"data-menuanchor="/get-started#firstPage2" class="dropdown-item" href="#">Web App Features</a>
                            <a  (click)="moveTo(3);"data-menuanchor="/get-started#firstPage3" class="dropdown-item" href="#">Mobile App Features</a>
                            <a  (click)="moveTo(4);"data-menuanchor="/get-started#secondPage" class="dropdown-item" href="#">APIs</a>
                            <a  (click)="moveTo(5);"data-menuanchor="/get-started#3rdPage" class="dropdown-item" href="#">Contact Us</a>
                        </div>
                    
                        <ul class="nav nav-pills" id="menu">
                    
                            <li (click)="moveTo(1);" data-menuanchor="/get-started#firstPage1" class="active"><a href="#">Get Started</a></li>
                            <li (click)="moveTo(2);" data-menuanchor="/get-started#firstPage2" class=""><a href="#">Web App Features</a></li>
                            <li (click)="moveTo(3);" data-menuanchor="/get-started#firstPage3" class=""><a href="#">Mobile App Features</a></li>
                            <li (click)="moveTo(4);" data-menuanchor="/get-started#secondPage"><a href="#">APIs</a></li>
                            <li (click)="moveTo(5);" id="contactUs" data-menuanchor="/get-started#3rdPage"><a href="#">Contact Us</a></li>
                        </ul>
                    
                    </div>
                </div>
                <div class="tab-content"  id="fullpage">

                    <div class="section" id="get-started#section0">
                        <div class="fieldUserContainer mCustomScrollbar" data-mcs-theme="minimal-dark">
                            <div class="getStartedSec">
                                <div class="getText">
                                    <h2>Effectively manage the daily activities of
                                        your field workforce with the <strong>power of location intelligence.</strong>
                                    </h2>
                                    <p>Get 10 users for 1 month with our free account. Want even more?
                                        Please contact our <a (click)="contactUs()" href="#">Enterprise team</a>.</p>
                                    <div class="getButtons">
                                        <button (click)="createAccount();" type="button" class="btn btn-default ripple blueBtn"><i
                                                class="material-icons">add</i>Create Account</button>
                                        <button (click)="userManual();" type="button" class="btn btn-default ripple lineBlueBtn"><i
                                                class="material-icons-outlined">info</i>Learn more About
                                            workmate</button>
                                    </div>
                                    <h6><strong>*Company Admin</strong> users are recommended to create the account,
                                        After the
                                        account creation, other team members will be invited by you.</h6>

                                </div>
                                <div class="getImg"><img src="assets/img/startedImg.png" alt=""></div>
                                <div class="getImg mobgetImg"><img src="assets/img/errorImg1.png" alt=""></div>

                            </div>
                        </div>
                    </div>
                    <div  class="section" id="get-started#section0">
                        <div class="fieldUserContainer mCustomScrollbar" data-mcs-theme="minimal-dark">


                            <div class="mobAppSec">
                                <h4>With the Workmate mobile app you can:</h4>
                                <div class="navDiv">

                                    <ul class="nav nav-pills scroll-touch">
                                        <li><a data-toggle="pill" href="#home" class="active">Monitor location-based
                                                Attendance</a></li>
                                        <li><a data-toggle="pill" href="#menu1">Digitally capture the Odometer
                                                reading</a></li>
                                        <li><a data-toggle="pill" href="#menu2">Automated reimbursement based on
                                                distance travelled.</a></li>
                                        <li><a data-toggle="pill" href="#menu3">Live location Tracking of your Field
                                                users. </a></li>
                                        <li><a data-toggle="pill" href="#menu4">Location-based task assignment </a></li>
                                        <li><a data-toggle="pill" href="#menu5">Capture your customer location</a></li>
                                        <li><a data-toggle="pill" href="#menu6">Give location intelligence to your field
                                                users.</a></li>
                                    </ul>
                                </div>
                                <div class="tab-content webApp">
                                    <div id="home" class="tab-pane fade in active">
                                        <div class="stepImg mobHide"><img src="assets/img/screen01.png" alt=""></div>
                                        <div class="stepImg mobstepImg"><img src="assets/img/mob_screen01.png" alt=""></div>
                                    </div>
                                    <div id="menu1" class="tab-pane fade">
                                        <div class="stepImg mobHide"><img src="assets/img/screen02.png" alt=""></div>
                                        <div class="stepImg mobstepImg"><img src="assets/img/mob_screen02.png" alt=""></div>
                                    </div>
                                    <div id="menu2" class="tab-pane fade">
                                        <div class="stepImg mobHide"><img src="assets/img/screen03.png" alt=""></div>
                                        <div class="stepImg mobstepImg"><img src="assets/img/mob_screen03.png" alt=""></div>
                                    </div>
                                    <div id="menu3" class="tab-pane fade">
                                        <div class="stepImg mobHide"><img src="assets/img/screen04.png" alt=""></div>
                                        <div class="stepImg mobstepImg"><img src="assets/img/mob_screen04.png" alt=""></div>
                                    </div>
                                    <div id="menu4" class="tab-pane fade">
                                        <div class="stepImg mobHide"><img src="assets/img/screen05.png" alt=""></div>
                                        <div class="stepImg mobstepImg"><img src="assets/img/mob_screen05.png" alt=""></div>
                                    </div>
                                    <div id="menu5" class="tab-pane fade">
                                        <div class="stepImg mobHide"><img src="assets/img/screen06.png" alt=""></div>
                                        <div class="stepImg mobstepImg"><img src="assets/img/mob_screen06.png" alt=""></div>
                                    </div>
                                    <div id="menu6" class="tab-pane fade">
                                        <div class="stepImg mobHide"><img src="assets/img/screen07.png" alt=""></div>
                                        <div class="stepImg mobstepImg"><img src="assets/img/mob_screen07.png" alt=""></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="section" id="get-started#section0">
                        <div class="fieldUserContainer mCustomScrollbar" data-mcs-theme="minimal-dark">


                            <div class="mobAppSec">
                                <h4>With the Workmate mobile app you can:</h4>
                                <div class="navDiv">

                                    <ul class="nav nav-pills scroll-touch">
                                        <li><a data-toggle="pill" href="#home10" class="active">Mark your attendance</a>
                                        </li>
                                        <li><a data-toggle="pill" href="#menu11">Capture odometer reading</a></li>
                                        <li><a data-toggle="pill" href="#menu21">Claim your reimbursement</a></li>
                                        <li><a data-toggle="pill" href="#menu31">Navigate to a customer location </a>
                                        </li>
                                        <li><a data-toggle="pill" href="#menu41">Live Location Tracking</a></li>
                                        <li><a data-toggle="pill" href="#menu51">Perform task at customer location</a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="tab-content">
                                    <div id="home10" class="tab-pane fade in active">
                                        <div class="stepImg"><img src="assets/img/appImg1.png" alt=""></div>
                                    </div>
                                    <div id="menu11" class="tab-pane fade">
                                        <div class="stepImg"><img src="assets/img/appImg2.png" alt=""></div>
                                    </div>
                                    <div id="menu21" class="tab-pane fade">
                                        <div class="stepImg"><img src="assets/img/appImg3.png" alt=""></div>
                                    </div>
                                    <div id="menu31" class="tab-pane fade">
                                        <div class="stepImg"><img src="assets/img/appImg4.png" alt=""></div>
                                    </div>
                                    <div id="menu41" class="tab-pane fade">
                                        <div class="stepImg"><img src="assets/img/appImg5.png" alt=""></div>
                                    </div>
                                    <div id="menu51" class="tab-pane fade">
                                        <div class="stepImg"><img src="assets/img/appImg6.png" alt=""></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="section" id="get-started#section1">
                        <div class="fieldUserContainer mCustomScrollbar" data-mcs-theme="minimal-dark">
                            <div class="customAppSec">
                                <div class="customAppText">
                                    <h3>Workmate APIs</h3>
                                    <p>A set of powerful workforce management APIs which helps the user to get all the
                                        data related to their organizations such as live location employees, client
                                        details and task details etc.</p>
                                    <p>These workforce management APIs are powered by MapmyIndia's own Map, IoT and
                                        workmate platform. MapmyIndia Workmate easily integrates into existing cloud
                                        services via our workforce management APIs. These APIs helps to improve the
                                        organizational effiency by providing location intellegence to employees.</p>
                                    <button type="button" class="btn btn-default ripple blueBtn" (click)="navToDiscoverApis()">Discover APIs</button>

                                </div>
                                <div class="customAppImg"><img src="assets/img/apiImg.png" alt=""></div>
                            </div>
                        </div>
                    </div>
                    <div class="section" id="get-started#3rdPage">
                        <div class="fieldUserContainer mCustomScrollbar" data-mcs-theme="minimal-dark">
                            <div class="customAppSec">
                                <div class="customAppText">
                                    <h3>Contact our Enterprise team</h3>
                                    <p>We're happy to answer questions and get you acquainted with workmate.</p>
                                    <ul class="customAppList">
                                        <li><i class="material-icons">check</i>Learn how to Manage your field force</li>
                                        <li><i class="material-icons">check</i>Get pricing</li>
                                        <li><i class="material-icons">check</i>Explore use cases for your industry</li>
                                    </ul>
                                    <button [disabled]="isCallBackLinkDisable" (click)="requestCallBack()" type="button" class="btn btn-default ripple blueBtn">Request a call
                                        back</button>

                                </div>
                                <div class="customAppImg"><img src="assets/img/contactImg.png" alt=""></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
